import {texts} from '../../Localization/texts';
import {entity} from '../../features/Automations/texts';

export default texts[entity];
